import { CircularProgress, Stack, StackProps } from '@mui/material';

export function LoadingProgress(props: StackProps) {
  return (
    <Stack justifyContent='center' alignItems='center' {...props}>
      <CircularProgress />
    </Stack>
  );
}
